// Which language the app boots in. Extracted from i18n.js as a pure function so the
// rule can be unit-tested — it decides which single language bundle gets fetched, and
// getting it wrong means booting in the wrong language or fetching the wrong chunk.
//
// Precedence: ?lang= in the URL, then the value saved in localStorage, then the
// marketplace default. Unsupported values at any level fall through to the next.

export const SUPPORTED_LANGS = ['en', 'he'];

export const isSupportedLang = (value) => SUPPORTED_LANGS.includes(value);

/**
 * @param {object} args
 * @param {string} [args.search] - location.search, e.g. '?lang=en'
 * @param {string} [args.storedLang] - value already in localStorage (null when unavailable)
 * @param {string} args.defaultLang - marketplace default language code
 * @returns {{ lang: string, fromUrl: boolean }} fromUrl marks that it should be persisted
 */
export const resolveInitialLanguage = ({ search = '', storedLang = null, defaultLang }) => {
  const langFromUrl = new URLSearchParams(search).get('lang');

  if (isSupportedLang(langFromUrl)) {
    return { lang: langFromUrl, fromUrl: true };
  }

  if (isSupportedLang(storedLang)) {
    return { lang: storedLang, fromUrl: false };
  }

  return { lang: defaultLang, fromUrl: false };
};
